import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as SentryInstance from '@sentry/browser';
import levels from '../config/levels';

var Sentry = /*#__PURE__*/function () {
  function Sentry() {
    var _this = this;

    var loggerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, Sentry);

    this.loggerName = loggerName;
    levels.forEach(function (method) {
      _this[method] = _this.wrapMethod(method);
    });
  }

  _createClass(Sentry, [{
    key: "getName",
    value: function getName() {
      return 'sentry';
    }
  }, {
    key: "captureException",
    value: function captureException(exception) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      SentryInstance.captureException(exception, this.parseArgs('error', args));
    }
  }, {
    key: "captureBreadcrumb",
    value: function captureBreadcrumb() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var message = args[0],
          restArgs = args.slice(1);

      var _this$parseArgs = this.parseArgs('log', restArgs),
          logger = _this$parseArgs.logger,
          extra = _this$parseArgs.extra,
          restData = _objectWithoutProperties(_this$parseArgs, ["logger", "extra"]);

      SentryInstance.addBreadcrumb(_objectSpread({
        message: message,
        category: logger,
        data: extra
      }, restData));
    }
  }, {
    key: "wrapMethod",
    value: function wrapMethod(method) {
      var _this2 = this;

      return function () {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        if (args.length === 0) {
          throw new Error('At least one argument must be provided');
        }

        var message = args[0],
            restArgs = args.slice(1);
        SentryInstance.captureMessage(message, _this2.parseArgs(method, restArgs));
      };
    }
  }, {
    key: "parseArgs",
    value: function parseArgs(method, args) {
      var level = method;

      if (['log', 'debug'].includes(method)) {
        level = 'info';
      } else if (method === 'warn') {
        level = 'warning';
      }

      var extra = null;
      var sentryData = {};

      if (Array.isArray(args) && args.length > 0) {
        var copyOfArgs = _toConsumableArray(args);

        if (copyOfArgs.length > 0) {
          var argsWithoutSentryData = copyOfArgs.map(function (arg) {
            if (arg !== null && _typeof(arg) === 'object' && arg.fingerprint !== 'undefined') {
              sentryData.fingerprint = arg.fingerprint;

              var copyOfArg = _objectSpread({}, arg);

              delete copyOfArg.fingerprint;
              return _objectSpread({}, copyOfArg);
            }

            return arg;
          });
          extra = this.convertToObject(_toConsumableArray(argsWithoutSentryData));
        }
      }

      return _objectSpread({
        level: level,
        extra: extra,
        logger: this.loggerName
      }, sentryData);
    }
  }, {
    key: "convertToObject",
    value: function convertToObject(item) {
      if (Array.isArray(item)) {
        var data = {};
        item.forEach(function (value, key) {
          data[key] = value;
        });
        return data;
      }

      return {
        data: item
      };
    }
  }]);

  return Sentry;
}();

export { Sentry as default };